import './common.css';
import tbhLogo from '../assets/images/tbh/tbhLogo.svg';
import { landingPageUrl } from '../utils/constants';
import { Img } from '@chakra-ui/react';

type TbhLogoWithTextProps = {
  width?: string;
  height?: string;
};

export function TbhLogoWithText({ width, height }: TbhLogoWithTextProps) {
  const url: any = landingPageUrl;
  return (
    <div
      className='flex  flex-row justify-center cursor-pointer'
      onClick={() => window.location.replace(url)}
    >
      <Img src={tbhLogo} width={width ?? '6rem'} height={height ?? '2.5rem'} alt='company logo' />
    </div>
  );
}

export default TbhLogoWithText;
